const name = 'asyncExample'
export default name
